import { defineMessages } from 'react-intl';

const messages = defineMessages({
    login: {
        id: 'app.login',
        defaultMessage: 'Login',
        description: 'Login Nav link',
    },
    signup: {
        id: 'app.signup',
        defaultMessage: 'Sign up',
        description: 'Sign up Nav link',
    },
    contact: {
        id: 'app.contact',
        defaultMessage: 'Contact',
        description: 'Contact Nav link',
    },
    logo: {
        id: 'app.logo',
        defaultMessage: 'Logo',
        description: 'Logo'
    },
    siteSettings: {
        id: 'app.siteSettings',
        defaultMessage: 'Site Settings',
        description: 'Site Settings'
    },
    HomeSiteSettings: {
        id: 'app.HomeSiteSettings',
        defaultMessage: 'Homepage Settings',
        description: 'HomeSiteSettings'
    },
    messageRequired: {
        id: 'app.messageRequired',
        defaultMessage: 'Message is required',
        description: 'Message is required'
    },
    ogImageTooltip: {
        id: 'app.ogImageTooltip',
        defaultMessage: 'It\'s the image that represents your webpage when shared on platforms like Facebook, X, or LinkedIn.(Recommended size: at least 1,200 x 630 pixels with a file size under 8MB)',
        description: 'Tooltip'
    },
    ogImageLabel: {
        id: 'app.ogImageLabel',
        defaultMessage: 'OG Image',
        description: 'OG Image'
    },
    textAreaError: {
        id: 'app.textAreaError',
        defaultMessage: ' Limit exceeded! you can add up to 250 characters',
        description: 'Limit exceeded! you can add up to 250 characters'
    },
    messageLength: {
        id: 'app.messageLength',
        defaultMessage: 'Message must be 200 characters or less',
        description: 'Message must be 200 characters or less'
    },
    metaKeyword: {
        id: 'app.metaKeyword',
        defaultMessage: 'Keyword must be 255 characters or less',
        description: 'Keyword must be 255 characters or less'
    },
    metaTitle: {
        id: 'app.metaTitle',
        defaultMessage: 'Meta Title',
        description: 'Meta Title'
    },
    metaDescriptionText: {
        id: 'app.metaDescriptionText',
        defaultMessage: 'Meta Description',
        description: 'Meta Description'
    },
    metaDescription: {
        id: 'app.metaDescription',
        defaultMessage: 'Description must be 255 characters or less',
        description: 'Description must be 255 characters or less'
    },
    pageTitle: {
        id: 'app.pageTitle',
        defaultMessage: 'Page Title',
        description: 'Page Title'
    },
    pageUrl: {
        id: 'app.pageUrl',
        defaultMessage: 'Page URL',
        description: 'Page URL'
    },
    invalidUrl: {
        id: 'app.invalidUrl',
        defaultMessage: 'Invalid Page URL',
        description: 'Invalid Page URL'
    },
    ratings: {
        id: 'app.ratings',
        defaultMessage: 'Ratings',
        description: 'Ratings'
    },
    reasonRequired: {
        id: 'app.reasonRequired',
        defaultMessage: 'Reason is required',
        description: 'Reason is required'
    },
    exceedLimit100: {
        id: 'app.exceedLimit100',
        defaultMessage: 'Maximum 100 words',
        description: 'Maximum 100 words'
    },
    exceedLimit: {
        id: 'app.exceedLimit',
        defaultMessage: 'Exceeding character limit',
        description: 'Exceeding character limit'
    },
    cancelReason: {
        id: 'app.cancelReason',
        defaultMessage: 'Cancel Reason',
        description: 'Cancel Reason'
    },
    cancelledBy: {
        id: 'app.cancelledBy',
        defaultMessage: 'Cancelled By',
        description: 'Cancelled By'
    },
    changePassword: {
        id: 'app.changePassword',
        defaultMessage: 'Change Password',
        description: 'Change Password'
    },
    addCancelReason: {
        id: 'app.addCancelReason',
        defaultMessage: 'Add Cancel Reason',
        description: 'Add Cancel Reason'
    },
    editCancelReason: {
        id: 'app.editCancelReason',
        defaultMessage: 'Edit Cancel Reason',
        description: 'Edit Cancel Reason'
    },
    reason: {
        id: 'app.reason',
        defaultMessage: 'Reason',
        description: 'Reason'
    },
    manageNotifications: {
        id: 'app.manageNotifications',
        defaultMessage: 'Manage Notifications',
        description: 'Manage Notifications'
    },
    heading: {
        id: 'app.heading',
        defaultMessage: 'Heading',
        description: 'heading',
    },
    dummyText: {
        id: 'app.dummyText',
        defaultMessage: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.',
        description: 'dummyText',
    },
    aboutFooter: {
        id: 'app.aboutFooter',
        defaultMessage: 'About Us',
        description: 'AboutFooter',
    },
    contactUs: {
        id: 'app.contactUs',
        defaultMessage: 'Contact Us',
        description: 'contact',
    },
    adminpanel: {
        id: 'app.adminpanel',
        defaultMessage: 'Admin Panel',
        description: 'admin panel',
    },
    dashboard: {
        id: 'app.dashboard',
        defaultMessage: 'Dashboard',
        description: 'dashboard',
    },
    settings: {
        id: 'app.settings',
        defaultMessage: 'Settings',
        description: 'settings',
    },
    users: {
        id: 'app.users',
        defaultMessage: 'Users',
        description: 'users',
    },
    formssidebar: {
        id: 'app.formssidebar',
        defaultMessage: 'Forms',
        description: 'formssidebar',
    },
    email: {
        id: 'app.emailaddress',
        defaultMessage: 'Email Address',
        description: 'emailaddress',
    },
    emailaddress: {
        id: 'app.emailaddress',
        defaultMessage: 'Email Address',
        description: 'emailaddress',
    },
    password: {
        id: 'app.password',
        defaultMessage: 'Password',
        description: 'password',
    },
    select: {
        id: 'app.select',
        defaultMessage: 'Select',
        description: 'select',
    },
    textarea: {
        id: 'app.textarea',
        defaultMessage: 'Text Area',
        description: 'textarea',
    },
    firstName: {
        id: 'app.firstName',
        defaultMessage: 'First Name',
        description: 'firstName',
    },
    lastName: {
        id: 'app.lastName',
        defaultMessage: 'Last Name',
        description: 'lastName',
    },
    companyName: {
        id: 'app.companyName',
        defaultMessage: 'Company Name',
        description: 'companyName',
    },
    workLicenceNumber: {
        id: 'app.workLicenceNumber',
        defaultMessage: 'Work Licence Number',
        description: 'workLicenceNumber',
    },
    phoneNumber: {
        id: 'app.phoneNumber',
        defaultMessage: 'Phone Number',
        description: 'phoneNumber',
    },
    profilePicture: {
        id: 'app.profilePicture',
        defaultMessage: 'Profile Picture',
        description: 'profilePicture',
    },
    required: {
        id: 'app.required',
        defaultMessage: '*Required',
        description: 'required error message',
    },
    emailRequired: {
        id: 'app.emailRequired',
        defaultMessage: 'Email is required',
        description: 'Email is required',
    },
    emailInvalid: {
        id: 'app.emailInValid',
        defaultMessage: 'Invalid Email Address',
        description: 'Invalid Email Address',
    },
    emailNotExists: {
        id: 'app.emailNotExists',
        defaultMessage: 'No account exists for this email. Make sure it\'s typed in correctly, or “sign up” instead',
        description: 'Email Address is not exist',
    },
    passwordRequired: {
        id: 'app.passwordRequired',
        defaultMessage: 'Password is required',
        description: 'Password is required',
    },
    passwordInvalid: {
        id: 'app.passwordInValid',
        defaultMessage: 'Your password must be at least 8 characters. Please try again',
        description: 'Invalid Password',
    },
    passwordWrong: {
        id: 'app.passwordWrong',
        defaultMessage: 'Wrong Password. Please try again',
        description: 'Wrong Password',
    },
    loggedIn: {
        id: 'app.loggedIn',
        defaultMessage: 'You are already logged in!',
        description: 'You are already Logged-in',
    },
    submitButton: {
        id: 'app.submitButton',
        defaultMessage: 'Submit',
        description: 'Submit',
    },
    cancelButton: {
        id: 'app.cancelButton',
        defaultMessage: 'Cancel',
        description: 'Cancel',
    },
    table: {
        id: 'app.table',
        defaultMessage: 'Table',
        description: 'Table',
    },
    form: {
        id: 'app.form',
        defaultMessage: 'Form',
        description: 'form',
    },
    menuOne: {
        id: 'app.menuOne',
        defaultMessage: 'MenuOne',
        description: 'form',
    },
    menuTwo: {
        id: 'app.menuTwo',
        defaultMessage: 'MenuTwo',
        description: 'MenuTwo',
    },
    menuFour: {
        id: 'app.menuFour',
        defaultMessage: 'MenuFour',
        description: 'menuFour',
    },
    subMenuOne: {
        id: 'app.subMenuOne',
        defaultMessage: 'subMenuOne',
        description: 'subMenuOne',
    },
    subMenuTwo: {
        id: 'app.subMenuTwo',
        defaultMessage: 'subMenuTwo',
        description: 'subMenuTwo',
    },
    subMenuThree: {
        id: 'app.subMenuThree',
        defaultMessage: 'subMenuThree',
        description: 'subMenuThree',
    },
    siteAdmin: {
        id: 'app.siteAdmin',
        defaultMessage: 'Site Admin',
        description: 'siteAdmin',
    },
    usersMenu: {
        id: 'app.usersMenu',
        defaultMessage: 'Manage Users',
        description: 'usersMenu',
    },
    partnerMenu: {
        id: 'app.partnerMenu',
        defaultMessage: 'Manage Service Providers',
        description: 'partnerMenu',
    },
    categoryMenu: {
        id: 'app.categoryMenu',
        defaultMessage: 'Manage Categories',
        description: 'categoryMenu',
    },
    categorieslist: {
        id: 'app.categorieslist',
        defaultMessage: 'Categories',
        description: 'categoryMenu',
    },
    bookingsMenu: {
        id: 'app.bookingsMenu',
        defaultMessage: 'Manage Jobs',
        description: 'bookingsMenu',
    },
    city: {
        id: 'app.city',
        defaultMessage: 'Lorem Ipsum is simply dummy text',
        description: 'city',
    },
    categoryTitle: {
        id: 'app.categoryTitle',
        defaultMessage: 'Category Title',
        description: 'Category Title',
    },
    categoryContent: {
        id: 'app.categoryContent',
        defaultMessage: 'Category Content',
        description: 'Category Content',
    },
    viewCity: {
        id: 'app.viewCity',
        defaultMessage: 'View city',
        description: 'view City',
    },
    Safety: {
        id: 'app.Safety',
        defaultMessage: 'Safety',
        description: 'Safety',
    },
    safetyContent: {
        id: 'app.safetyContent',
        defaultMessage: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.',
        description: 'Safety',
    },
    safetyButton: {
        id: 'app.safetyButton',
        defaultMessage: 'View all safety features',
        description: 'safetyButton',
    },
    signupDrive: {
        id: 'app.signupDrive',
        defaultMessage: 'Sign up to drive',
        description: 'Sign up to drive',
    },
    signupRide: {
        id: 'app.signupRide',
        defaultMessage: 'Sign up to ride',
        description: 'Sign up to ride',
    },
    profileId: {
        id: 'app.profileId',
        defaultMessage: 'Profile ID',
        description: 'Profile Id for user'
    },
    country: {
        id: 'app.country',
        defaultMessage: 'Country',
        description: 'Country Name'
    },
    serviceArea: {
        id: 'app.serviceArea',
        defaultMessage: 'Service Area',
        description: 'Service provider preferred job location'
    },
    servicesOffered: {
        id: 'app.servicesOffered',
        defaultMessage: 'Services',
        description: 'Services offered by the provider'
    },
    createdAt: {
        id: 'app.createdAt',
        defaultMessage: 'Account Created on',
        description: 'Created date'
    },
    action: {
        id: 'app.action',
        defaultMessage: 'Action',
        description: 'Action'
    },
    basePrice: {
        id: 'app.basePrice',
        defaultMessage: 'Base Price',
        description: 'base price amount'
    },
    status: {
        id: 'app.status',
        defaultMessage: 'Status',
        description: 'Status Active/Inactive'
    },
    editAction: {
        id: 'app.editAction',
        defaultMessage: 'Edit',
        description: 'Edit action name'
    },
    deleteAction: {
        id: 'app.deleteAction',
        defaultMessage: 'Delete',
        description: 'Delete action name'
    },
    minutePrice: {
        id: 'app.minutePrice',
        defaultMessage: 'Minute Price',
        description: 'Minute Price'
    },
    unitPrice: {
        id: 'app.unitPrice',
        defaultMessage: 'Unit Price',
        description: 'Unit Price'
    },
    fixedFeeType: {
        id: 'app.fixed',
        defaultMessage: 'Fixed',
        description: 'Fixed Fee Type'
    },
    percentageFeeType: {
        id: 'app.percentageFeeType',
        defaultMessage: 'Percentage',
        description: 'Percentage Fee Type'
    },
    totalFare: {
        id: 'app.totalFare',
        defaultMessage: 'Total Fare',
        description: 'Total Fare'
    },
    promoCodeId: {
        id: 'app.promoCodeId',
        defaultMessage: 'Promo Code',
        description: 'Promo Code'
    },
    platformDiscount: {
        id: 'app.platformDiscount',
        defaultMessage: 'Platform offered discount',
        description: 'Special platformDiscount'
    },
    userDiscount: {
        id: 'app.userDiscount',
        defaultMessage: 'Coupon Discount',
        description: 'discount text'
    },
    userPayableAmount: {
        id: 'app.userPayableAmount',
        defaultMessage: 'User Payable Amount',
        description: 'userPayableAmount'
    },
    bookingStatus: {
        id: 'app.bookingStatus',
        defaultMessage: 'Job Status',
        description: 'Job Status'
    },
    userName: {
        id: 'app.userName',
        defaultMessage: 'User Name',
        description: 'User Name'
    },
    partnerName: {
        id: 'app.partnerName',
        defaultMessage: 'Service Provider Name',
        description: 'Service Provider Name'
    },
    userEmail: {
        id: 'app.userEmail',
        defaultMessage: 'User Email',
        description: 'User Email'
    },
    partnerEmail: {
        id: 'app.partnerEmail',
        defaultMessage: 'Service Provider Email',
        description: 'Service Provider Email'
    },
    pickUpLocation: {
        id: 'app.pickupLocation',
        defaultMessage: 'Pickup Location',
        description: 'PickUp Location'
    },
    dropLocation: {
        id: 'app.dropLocation',
        defaultMessage: 'Drop Location',
        description: 'Drop Location'
    },
    bookingId: {
        id: 'app.bookingId',
        defaultMessage: 'Booking ID',
        description: 'Booking ID'
    },
    category: {
        id: 'app.category',
        defaultMessage: 'Category',
        description: 'Category'
    },
    inclusions: {
        id: 'app.inclusions',
        defaultMessage: 'What this service includes',
        description: 'Checklist shown on the service screen in the app'
    },
    totalRideDistance: {
        id: 'app.totalRideDistance',
        defaultMessage: 'Total  Distance',
        description: 'Total  Distance'
    },
    totalDuration: {
        id: 'app.totalDuration',
        defaultMessage: 'Total Duration',
        description: 'Total Duration'
    },
    categoryId: {
        id: 'app.categoryId',
        defaultMessage: 'Category ID',
        description: 'Category ID'
    },
    view: {
        id: 'app.view',
        defaultMessage: 'View',
        description: 'View Details Link'
    },
    details: {
        id: 'app.details',
        defaultMessage: 'Details',
        description: 'Details'
    },
    userServiceFee: {
        id: 'app.userServiceFee',
        defaultMessage: 'User Service Fee',
        description: 'User Service Fee'
    },
    partnerServiceFee: {
        id: 'app.partnerServiceFee',
        defaultMessage: 'Service Provider Service Fee',
        description: 'Service Provider Service Fee'
    },
    tripStart: {
        id: 'app.tripStart',
        defaultMessage: 'Trip Start',
        description: 'Trip Start'
    },
    tripEnd: {
        id: 'app.tripEnd',
        defaultMessage: 'Trip End',
        description: 'Trip End'
    },
    categoryName: {
        id: 'app.categoryName',
        defaultMessage: 'Category Name',
        description: 'Category Name'
    },
    categoryLogo: {
        id: 'app.categoryLogo',
        defaultMessage: 'Logo',
        description: 'Category Logo'
    },
    categoryBanner: {
        id: 'app.categoryBanner',
        defaultMessage: 'Banner',
        description: 'Category Banner'
    },
    isPopular: {
        id: 'app.isPopular',
        defaultMessage: 'Is-Popular',
        description: 'Is-Popular'
    },
    isDirectBooking: {
        id: 'app.isDirectBooking',
        defaultMessage: 'Direct Booking (pay upfront, assign provider later)',
        description: 'isDirectBooking'
    },
    directBookingMenu: {
        id: 'app.directBookingMenu',
        defaultMessage: 'Direct Bookings',
        description: 'directBookingMenu'
    },
    selectProvider: {
        id: 'app.selectProvider',
        defaultMessage: 'Select provider',
        description: 'selectProvider'
    },
    assignProvider: {
        id: 'app.assignProvider',
        defaultMessage: 'Assign',
        description: 'assignProvider'
    },
    isJobPhotoRequired: {
        id: 'app.isJobPhotoRequired',
        defaultMessage: 'Allow users to upload photos for the job',
        description: 'isJobPhotoRequired'
    },
    pricingType: {
        id: 'app.pricingType',
        defaultMessage: 'Pricing Type',
        description: 'Pricing Type'
    },
    minutes: {
        id: 'app.minutes',
        defaultMessage: 'minutes',
        description: 'minutes'
    },
    update: {
        id: 'app.update',
        defaultMessage: 'Update',
        description: 'Update'
    },
    userStatus: {
        id: 'app.userStatus',
        defaultMessage: 'User Status',
        description: 'User Status Active/Inactive'
    },
    active: {
        id: 'app.active',
        defaultMessage: 'Active',
        description: 'Active Status'
    },
    inactive: {
        id: 'app.inactive',
        defaultMessage: 'Inactive',
        description: 'Inactive Status'
    },
    pending: {
        id: 'app.pending',
        defaultMessage: 'Pending',
        description: 'Pending Status'
    },
    banStatus: {
        id: 'app.banStatus',
        defaultMessage: 'Ban Status',
        description: 'Ban Status Permit/Ban'
    },
    permit: {
        id: 'app.permit',
        defaultMessage: 'Permit',
        description: 'Permit Status'
    },
    ban: {
        id: 'app.ban',
        defaultMessage: 'Ban',
        description: 'Ban Status'
    },
    phoneDialCode: {
        id: 'app.phoneDialCode',
        defaultMessage: 'Country Code',
        description: 'Phone Dial Code'
    },
    dropzoneUpload: {
        id: "app.dropzoneUpload",
        defaultMessage: "Upload a file from your computer",
        description: "Dropzone upload info"
    },
    dropzoneUploadError: {
        id: "app.dropzoneUploadError",
        defaultMessage: "Remove the existing image and try upload again",
        description: "Dropzone upload error message"
    },
    addCategory: {
        id: 'app.addCategory',
        defaultMessage: 'Add Category',
        description: 'Add category form header'
    },
    editUser: {
        id: 'app.editUser',
        defaultMessage: 'Edit User',
        description: 'Edit User form header'
    },
    editPartner: {
        id: 'app.editPartner',
        defaultMessage: 'Edit Service Provider',
        description: 'Edit Service Provider form header'
    },
    editCategory: {
        id: 'app.editCategory',
        defaultMessage: 'Edit Category',
        description: 'Edit category form header'
    },
    goBack: {
        id: 'app.goBack',
        defaultMessage: 'Go Back',
        description: 'Go Back Button Text'
    },
    capacity: {
        id: 'app.capacity',
        defaultMessage: 'Capacity',
        description: 'Capacity'
    },
    floatError: {
        id: 'app.floatError',
        defaultMessage: 'It should be a number value',
        description: 'Numeric Error Response'
    },
    numericValue: {
        id: 'app.numericValue',
        defaultMessage: 'Numeric value required',
        description: 'Numeric value required'
    },
    validUrl: {
        id: 'app.validUrl',
        defaultMessage: 'Valid URL required',
        description: 'Valid URL required'
    },
    intError: {
        id: 'app.intError',
        defaultMessage: 'It should be a decimal value',
        description: 'Integer Error Response'
    },
    percentError: {
        id: 'app.percentError',
        defaultMessage: 'Choose percentage value between 1 to 99',
        description: 'Choose percentage value between 1 to 99'
    },
    phoneError: {
        id: 'app.numberError',
        defaultMessage: 'Invalid Phone Number',
        description: 'Invalid Phone Number'
    },
    countryCodeError: {
        id: 'app.countryCodeError',
        defaultMessage: 'Invalid Country Code',
        description: 'Invalid Country Code'
    },
    availableSeats: {
        id: 'app.availableSeats',
        defaultMessage: 'Available Seats',
        description: 'Available Seats'
    },
    currency: {
        id: 'app.currency',
        defaultMessage: 'Currency',
        description: 'Currency Type'
    },
    manageDashboard: {
        id: 'app.manageDashboard',
        defaultMessage: 'Dashboard',
        description: 'Manage Dashboard'
    },
    chooseFile: {
        id: 'app.chooseFile',
        defaultMessage: 'Choose File',
        description: ''
    },
    categoryIcon: {
        id: 'app.categoryIcon',
        defaultMessage: 'Category Icon',
        description: ''
    },
    categoryMapMarker: {
        id: 'app.categoryMapMarker',
        defaultMessage: 'Category Map Marker',
        description: ''
    },
    maximumUploadSizeLabel: {
        id: 'app.maximumUploadSizeLabel',
        defaultMessage: 'Maximum upload size',
        description: ''
    },
    followUs: {
        id: 'app.followUs',
        defaultMessage: 'Follow  Us',
        description: 'Follow Us',
    },
    downloadAppText: {
        id: 'app.downloadAppText',
        defaultMessage: 'Download The User App',
        description: 'DownloadAppText',
    },
    downloadAppTextPartner: {
        id: 'app.downloadAppTextPartner',
        defaultMessage: 'Download The Service Provider App',
        description: 'DownloadAppText',
    },
    downloadAppDesc: {
        id: 'app.downloadAppDesc',
        defaultMessage: 'Delectus scaevola elaboraret vel ad, vis no noster vocent prodesset, nec ei omittantur dissentiet. Nobis postea ei est.',
        description: 'DownloadAppTextDesc',
    },
    user: {
        id: 'app.user',
        defaultMessage: 'User',
        description: 'user',
    },
    partner: {
        id: 'app.partner',
        defaultMessage: 'Service Provider',
        description: 'partner',
    },
    partners: {
        id: 'app.partners',
        defaultMessage: 'Service Providers',
        description: 'partner',
    },
    today: {
        id: 'app.today',
        defaultMessage: 'Today',
        description: 'today',
    },
    weekly: {
        id: 'app.weekly',
        defaultMessage: 'This Week',
        description: 'weekly',
    },
    montly: {
        id: 'app.montly',
        defaultMessage: 'This Month',
        description: 'montly',
    },
    bookings: {
        id: 'app.bookings',
        defaultMessage: 'Bookings',
        description: 'bookings',
    },

    logout: {
        id: 'app.logout',
        defaultMessage: 'Logout',
        description: 'logout option',
    },

    goToMainSite: {
        id: 'app.goToMainSite',
        defaultMessage: 'Go to main site',
        description: 'goToMainSite option',
    },

    managePromoCode: {
        id: 'app.managePromoCode',
        defaultMessage: 'Manage Promo Code',
        description: 'managePromoCode sidemenu',
    },
    addPromoCode: {
        id: 'app.addPromoCode',
        defaultMessage: 'Add Promo Code',
        description: 'Add PromoCode',
    },
    editPromoCode: {
        id: 'app.editPromoCode',
        defaultMessage: 'Edit Promo Code',
        description: 'Edit PromoCode',
    },
    addPage: {
        id: 'app.addPage',
        defaultMessage: "Add Page",
        description: "Add Page"
    },
    id: {
        id: 'app.id',
        defaultMessage: 'ID',
        description: 'ID text',
    },
    title: {
        id: 'app.title',
        defaultMessage: 'Title',
        description: 'text',
    },
    description: {
        id: 'app.description',
        defaultMessage: 'Description',
        description: 'text',
    },
    code: {
        id: 'app.code',
        defaultMessage: 'Code',
        description: 'text',
    },
    discount: {
        id: 'app.discount',
        defaultMessage: 'Discount',
        description: 'text',
    },
    promoType: {
        id: 'app.promoType',
        defaultMessage: 'Type',
        description: 'text',
    },
    expireDate: {
        id: 'app.expireDate',
        defaultMessage: 'Expiry Date',
        description: 'text',
    },
    percentage: {
        id: 'app.percentage',
        defaultMessage: 'Percentage',
        description: 'text',
    },
    fixedAmount: {
        id: 'app.fixedAmount',
        defaultMessage: 'Fixed Amount',
        description: 'text',
    },
    usedPromoCode: {
        id: 'app.usedPromoCode',
        defaultMessage: 'Used Promo Code',
        description: 'text',
    },
    manageCompletedBooking: {
        id: 'app.manageCompletedBooking',
        defaultMessage: 'Completed Jobs',
        description: 'CompletedBooking sidemenu',
    },
    manageCancelledBookings: {
        id: 'app.manageCancelledBookings',
        defaultMessage: 'Cancelled Jobs',
        description: 'manageCancelledBookings sidemenu',
    },
    manageCancelReason: {
        id: 'app.manageCancelReason',
        defaultMessage: 'Cancel Reason',
        description: 'Cancel Reason',
    },
    manageCurrency: {
        id: 'app.manageCurrency',
        defaultMessage: 'Manage Currency',
        description: 'manageCurrency sidemenu',
    },
    symbol: {
        id: 'app.symbol',
        defaultMessage: 'Symbol',
        description: 'currencyManagement value',
    },
    baseCurrency: {
        id: 'app.BaseCurrency',
        defaultMessage: 'Base Currency',
        description: 'currencyManagement value',
    },
    enableDisable: {
        id: 'app.enableDisable',
        defaultMessage: 'Set Enable / Disable',
        description: 'currencyManagement value',
    },
    setBaseCurrency: {
        id: 'app.setBaseCurrency',
        defaultMessage: 'Set Base Currency',
        description: 'currencyManagement value',
    },
    allowedPaymentCurrency: {
        id: 'app.allowedPaymentCurrency',
        defaultMessage: 'Allowed Payment Currency',
        description: 'currencyManagement value',
    },
    reviewsBy: {
        id: 'app.reviewsBy',
        defaultMessage: 'Reviews By',
        description: 'reviewsBy'
    },
    noResult: {
        id: 'app.noResult',
        defaultMessage: 'No results found',
        description: 'noResult'
    },
    addLocation: {
        id: 'app.addLocation',
        defaultMessage: 'Add Location',
        description: 'addLocation'
    },
    tollFee: {
        id: 'app.tollFee',
        defaultMessage: 'Toll Fee',
        description: 'tollFee'
    },
    location: {
        id: 'app.location',
        defaultMessage: 'Manage Location',
        description: 'location'
    },
    edit: {
        id: 'app.edit',
        defaultMessage: 'Edit',
        description: 'edit'
    },
    managePayout: {
        id: 'app.managePayout',
        defaultMessage: 'Manage Payout',
        description: 'managePayout'
    },
    partnerPayout: {
        id: 'app.partnerPayout',
        defaultMessage: 'Service Provider Payout',
        description: 'managePayout'
    },
    amount: {
        id: 'app.Amount',
        defaultMessage: 'Amount',
        description: 'Amount'
    },
    payoutStatus: {
        id: 'app.payoutStatus',
        defaultMessage: 'Payout Status',
        description: 'Payout Status'
    },
    holdPayout: {
        id: 'app.holdPayout',
        defaultMessage: 'Hold Payout',
        description: 'Hold Payout'
    },
    paymentType: {
        id: 'app.paymentType',
        defaultMessage: 'Payment Type',
        description: 'Payment Type'
    },
    yes: {
        id: 'app.yes',
        defaultMessage: 'Yes',
        description: 'Yes'
    },
    no: {
        id: 'app.no',
        defaultMessage: 'No',
        description: 'no'
    },
    homeSectionSettings: {
        id: 'app.homeSectionSettings',
        defaultMessage: 'Banner',
        description: 'Banner Settings'
    },
    homepageBanner: {
        id: 'app.homepageBanner',
        defaultMessage: 'Homepage Banner',
        description: 'Homepage Banner Settings'
    },
    aboutSectionSettings: {
        id: 'app.aboutSectionSettings',
        defaultMessage: 'Top Features',
        description: 'Top Features Settings'
    },
    citySectionSettings: {
        id: 'app.citySectionSettings',
        defaultMessage: 'Category',
        description: 'Category Settings'
    },
    safetySectionSettings: {
        id: 'app.safetySectionSettings',
        defaultMessage: 'User App',
        description: 'User Apps Settings'
    },
    signupSectionSettings: {
        id: 'app.signupSectionSettings',
        defaultMessage: 'Service Provider App',
        description: 'Service Provider Apps Settings'
    },
    footerSectionSettings: {
        id: 'app.footerSectionSettings',
        defaultMessage: 'Footer',
        description: 'Footer Settings'
    },
    manageFailedPayout: {
        id: 'app.manageFailedPayout',
        defaultMessage: 'Failed Payout',
        description: 'Failed Payout'
    },
    content: {
        id: 'app.content',
        defaultMessage: 'Content',
        description: 'Content 1'
    },
    button: {
        id: 'app.button',
        defaultMessage: 'Button',
        description: 'Button'
    },
    aboutImage1: {
        id: 'app.aboutImage1',
        defaultMessage: 'Feature Icon #1',
        description: 'Feature Icon 1'
    },
    aboutImage2: {
        id: 'app.aboutImage2',
        defaultMessage: 'Feature Icon #2',
        description: 'Feature Icon 2'
    },
    homeImage1: {
        id: 'app.homeImage1',
        defaultMessage: 'Banner Image #1',
        description: 'Banner Image 1'
    },
    homeImage2: {
        id: 'app.homeImage2',
        defaultMessage: 'Banner Image #2',
        description: 'Banner Image 2'
    },
    homeImage3: {
        id: 'app.homeImage3',
        defaultMessage: 'Banner Image #3',
        description: 'Banner Image 3'
    },
    homeTitle: {
        id: 'app.homeTitle',
        defaultMessage: 'Banner Title',
        description: 'Banner Title'
    },
    homeContent1: {
        id: 'app.homeContent1',
        defaultMessage: 'Banner Content',
        description: 'Banner Content'
    },
    safetyImage1: {
        id: 'app.safetyImage1',
        defaultMessage: 'Playstore Logo',
        description: 'Playstore Logo'
    },
    safetyImage2: {
        id: 'app.safetyImage2',
        defaultMessage: 'Appstore Logo',
        description: 'Appstore Logo'
    },
    safetyImage3: {
        id: 'app.safetyImage3',
        defaultMessage: 'User App Image',
        description: 'User App Image'
    },
    signupImage1: {
        id: 'app.signupImage1',
        defaultMessage: 'Play Store Logo',
        description: 'Playstore Logo'
    },
    signupImage2: {
        id: 'app.signupImage2',
        defaultMessage: 'App Store Logo',
        description: 'Appstore Logo'
    },
    signupImage3: {
        id: 'app.signupImage3',
        defaultMessage: 'Service Provider App Image',
        description: 'Service provider App Image'
    },
    earnings: {
        id: 'app.earnings',
        defaultMessage: 'Your Earnings',
        description: 'Earnings'
    },
    overAll: {
        id: 'app.overAll',
        defaultMessage: 'Overall',
        description: 'Overall'
    },
    approve: {
        id: 'app.approve',
        defaultMessage: 'Approve',
        description: 'Approve'
    },
    decline: {
        id: 'app.decline',
        defaultMessage: 'Decline',
        description: 'Decline'
    },
    online: {
        id: 'app.online',
        defaultMessage: 'Online',
        description: 'online'
    },
    offline: {
        id: 'app.offline',
        defaultMessage: 'Offline',
        description: 'offline'
    },
    eligibleForAService: {
        id: 'app.eligibleForAService',
        defaultMessage: 'Eligible for a Service',
        description: 'text'
    },
    notEligibleForAService: {
        id: 'app.notEligibleForAService',
        defaultMessage: 'Not eligible for a Service',
        description: 'text'
    },
    preview: {
        id: 'app.preview',
        defaultMessage: 'Preview',
        description: 'Preview'
    },
    pageName: {
        id: 'app.pageName',
        defaultMessage: 'Page Name',
        description: 'Page Name'
    },
    staticpageManagement: {
        id: 'app.staticpageManagement',
        defaultMessage: 'Manage Static Content',
        description: 'Manage Static Content'
    },
    contentpageManagement: {
        id: 'app.contentpageManagement',
        defaultMessage: 'Content Management',
        description: 'Content Management'
    },
    editPageDetails: {
        id: 'app.editPageDetails',
        defaultMessage: 'Edit Page Details',
        description: 'Edit Page Details'
    },
    pageBanner: {
        id: 'app.pageBanner',
        defaultMessage: 'Page Banner',
        description: 'Page Banner'
    },
    pageImageBanner: {
        id: 'app.pageImageBanner',
        defaultMessage: 'Page Image Banner',
        description: 'Page Image Banner'
    },
    manageFare: {
        id: 'app.manageFare',
        defaultMessage: 'Manage Fare',
        description: 'Admin sidemenu'
    },
    locationName: {
        id: 'app.locationName',
        defaultMessage: 'Location',
        description: 'Table header'
    },
    addFare: {
        id: 'app.addFare',
        defaultMessage: 'Add Fare',
        description: 'Button '
    },
    editFare: {
        id: 'app.adeditFaredFare',
        defaultMessage: 'Edit Fare',
        description: 'Button '
    },
    paid: {
        id: 'app.paid',
        defaultMessage: 'Paid',
        description: 'Paid'
    },
    unpaid: {
        id: 'app.unpaid',
        defaultMessage: 'Unpaid',
        description: 'Unpaid'
    },
    payoutAmount: {
        id: 'app.payoutAmount',
        defaultMessage: 'Payout Amount',
        description: 'Payout Amount'
    },
    searchLocation: {
        id: 'app.searchLocation',
        defaultMessage: 'Search Location',
        description: 'Auto-Complete input'
    },
    removeLocation: {
        id: 'app.removeLocation',
        defaultMessage: 'Remove Location',
        description: 'Polygon remove'
    },
    walletBalance: {
        id: 'app.walletBalance',
        defaultMessage: 'Wallet Balance',
        description: 'Wallet Balance'
    },
    paymentMethod: {
        id: 'app.paymentMethod',
        defaultMessage: 'Payment Method',
        description: 'Payment Method'
    },
    card: {
        id: 'app.card',
        defaultMessage: 'Card',
        description: 'Card'
    },
    cash: {
        id: 'app.cash',
        defaultMessage: 'Cash',
        description: 'Cash'
    },
    wallet: {
        id: 'app.wallet',
        defaultMessage: 'Wallet',
        description: 'Wallet'
    },
    exportDataIntoCSV: {
        id: 'app.exportDataIntoCSV',
        defaultMessage: 'Export Data into CSV',
        description: 'Export Data into CSV',
    },
    roleName: {
        id: 'app.roleName',
        defaultMessage: 'Role Name',
        description: 'Role Name',
    },
    privileges: {
        id: 'app.privileges',
        defaultMessage: 'Privileges',
        description: 'Privileges',
    },
    emailText: {
        id: 'app.emailText',
        defaultMessage: 'Email',
        description: 'Email',
    },
    adminRole: {
        id: 'app.adminRole',
        defaultMessage: 'Admin Role',
        description: 'Admin Role',
    },
    adminName: {
        id: 'app.adminName',
        defaultMessage: 'Name',
        description: 'Name'
    },
    passwordText: {
        id: 'app.passwordText',
        defaultMessage: 'Provide new password only. Ignore this field to use the existing password for this user.',
        description: 'Password Content',
    },
    selectRole: {
        id: 'app.selectRole',
        defaultMessage: 'Select Role',
        description: 'Select Role',
    },
    role: {
        id: 'app.role',
        defaultMessage: 'Role',
        description: 'Role',
    },
    manageAdmin: {
        id: 'app.manageAdmin',
        defaultMessage: 'Manage Admins',
        description: 'Manage Admins',
    },
    manageAdminUsers: {
        id: 'app.manageAdminUsers',
        defaultMessage: 'Manage Admin Users',
        description: 'Manage Admin Users',
    },
    manageAdminRoles: {
        id: 'app.manageAdminRoles',
        defaultMessage: 'Manage Admin Roles',
        description: 'Manage Admin Roles',
    },
    adminUserLabel: {
        id: 'app.adminUserLabel',
        defaultMessage: 'Admin User',
        description: 'Admin User',
    },
    addNewLabel: {
        id: 'app.addNewLabel',
        defaultMessage: 'Add New',
        description: 'Add New',
    },
    chooseLanguageLabel: {
        id: 'app.chooseLanguageLabel',
        defaultMessage: 'Choose a language',
        description: 'Choose a language',
    },
    askQuestion: {
        id: 'app.askQuestion',
        defaultMessage: 'Ask a question',
        description: 'Ban Status'
    },
    reportIssue: {
        id: 'app.reportIssue',
        defaultMessage: 'Report an issue',
        description: 'Ban Status'
    },
    Enabled: {
        id: 'app.Enabled',
        defaultMessage: 'Enabled',
        description: 'Ban Status'
    },
    Disabled: {
        id: 'app.Disabled',
        defaultMessage: 'Disabled',
        description: 'Ban Status'
    },
    Enable: {
        id: 'app.Enable',
        defaultMessage: 'Enable',
        description: 'Ban Status'
    },
    Disable: {
        id: 'app.Disable',
        defaultMessage: 'Disable',
        description: 'Ban Status'
    },
    setBase: {
        id: 'app.setBase',
        defaultMessage: 'Set as base currency',
        description: 'Ban Status'
    },
    Support: {
        id: 'app.Support',
        defaultMessage: 'Support',
        description: 'Ban Status'
    },
    totalUser: {
        id: 'app.totalUser',
        defaultMessage: 'Total Users',
        description: 'Ban Status'
    },
    totalList: {
        id: 'app.totalList',
        defaultMessage: 'Total Listings',
        description: 'Ban Status'
    },
    totalReserv: {
        id: 'app.totalReserv',
        defaultMessage: 'Total Reservations',
        description: 'Ban Status'
    },
    lastHours: {
        id: 'app.lastHours',
        defaultMessage: 'Last 24 hours',
        description: 'Ban Status'
    },
    listings: {
        id: 'app.listings',
        defaultMessage: 'Listings',
        description: 'Ban Status'
    },
    reservations: {
        id: 'app.reservations',
        defaultMessage: 'Reservations',
        description: 'Ban Status'
    },
    notFound: {
        id: 'app.notFound',
        defaultMessage: 'Sorry, the page you were trying to view does not exist.',
        description: 'Ban Status'
    },
    oneOne: {
        id: 'app.oneOne',
        defaultMessage: 'One',
        description: 'Ban Status'
    },
    currencies: {
        id: 'app.currencies',
        defaultMessage: 'Currencies',
        description: 'Ban Status'
    },
    fares: {
        id: 'app.fares',
        defaultMessage: 'Fares',
        description: 'Fares'
    },
    homeonly: {
        id: 'app.homeonly',
        defaultMessage: 'Home',
        description: 'Fares'
    },
    allonly: {
        id: 'app.allonly',
        defaultMessage: 'All',
        description: 'Fares'
    },
    playstorelink: {
        id: 'app.playstorelink',
        defaultMessage: 'Play Store Link',
        description: 'Fares'
    },
    appstorelink: {
        id: 'app.appstorelink',
        defaultMessage: 'App Store Link',
        description: 'Fares'
    },
    partnerappcntn: {
        id: 'app.partnerappcntn',
        defaultMessage: 'Service Provider App Content',
        description: 'Fares'
    },
    partnerapptitle: {
        id: 'app.partnerapptitle',
        defaultMessage: 'Service Provider App Title',
        description: 'Fares'
    },
    logowidth: {
        id: 'app.logowidth',
        defaultMessage: 'Logo Width',
        description: 'Fares'
    },
    logoheight: {
        id: 'app.logoheight',
        defaultMessage: 'Logo Height',
        description: 'Fares'
    },
    siteName: {
        id: 'app.siteName',
        defaultMessage: 'Site Name',
        description: 'Fares'
    },
    siteTitle: {
        id: 'app.siteTitle',
        defaultMessage: 'Site Title',
        description: 'Fares'
    },
    metakey: {
        id: 'app.metakey',
        defaultMessage: 'Meta Keyword',
        description: 'Fares'
    },
    metaDesc: {
        id: 'app.metaDesc',
        defaultMessage: 'Meta Description',
        description: 'Fares'
    },
    youtubeUrl: {
        id: 'app.youtubeUrl',
        defaultMessage: 'Youtube URL',
        description: 'Fares'
    },
    miles: {
        id: 'app.miles',
        defaultMessage: 'Miles',
        description: 'Fares'
    },
    errorOnly: {
        id: 'app.errorOnly',
        defaultMessage: 'Error',
        description: 'Fares'
    },
    credentialError: {
        id: 'app.credentialError',
        defaultMessage: 'Sorry, a critical error occurred on this page.',
        description: 'Fares'
    },
    addOnly: {
        id: 'app.addOnly',
        defaultMessage: 'Address',
        description: 'Fares'
    },
    state: {
        id: 'app.state',
        defaultMessage: 'State',
        description: 'Fares'
    },
    checkmein: {
        id: 'app.checkmein',
        defaultMessage: 'Check me in',
        description: 'Fares'
    },
    checkmeout: {
        id: 'app.checkmeout',
        defaultMessage: 'Check me out',
        description: 'Fares'
    },
    tableHead: {
        id: 'app.tableHead',
        defaultMessage: 'Table heading',
        description: 'Fares'
    },
    tableCell: {
        id: 'app.tableCell',
        defaultMessage: 'Table cell',
        description: 'Fares'
    },
    redioOne: {
        id: 'app.redioOne',
        defaultMessage: 'radio 1',
        description: 'Fares'
    },
    optionOne: {
        id: 'app.optionOne',
        defaultMessage: 'option 1',
        description: 'Fares'
    },
    confirmPassword: {
        id: 'app.confirmPassword',
        defaultMessage: 'Confirm Password',
        description: 'Change Password'
    },
    nameOnly: {
        id: 'app.nameOnly',
        defaultMessage: 'Name',
        description: 'Change Password'
    },
    msgOnly: {
        id: 'app.msgOnly',
        defaultMessage: 'Message',
        description: 'Change Password'
    },
    featureTitle1: {
        id: 'app.featureTitle1',
        defaultMessage: 'Feature title',
        description: 'Change Password'
    },
    featureDesc1: {
        id: 'app.featureDesc1',
        defaultMessage: 'Feature description',
        description: 'Change Password'
    },
    footerTitle1: {
        id: 'app.footerTitle1',
        defaultMessage: 'Footer Title #1',
        description: 'Change Password'
    },
    footerContent1: {
        id: 'app.footerContent1',
        defaultMessage: 'Footer Content #1',
        description: 'Change Password'
    },
    footerUrltitle: {
        id: 'app.footerUrltitle',
        defaultMessage: 'Footer URL Title',
        description: 'Change Password'
    },
    copyRightcontent: {
        id: 'app.copyRightcontent',
        defaultMessage: 'Copyrights content',
        description: 'Change Password'
    },
    radioButton: {
        id: 'app.radioButton',
        defaultMessage: 'Radio button',
        description: 'Change Password'
    },
    userApptitle: {
        id: 'app.userApptitle',
        defaultMessage: 'User App Title',
        description: 'Change Password'
    },
    userAppContent: {
        id: 'app.userAppContent',
        defaultMessage: 'User App Content',
        description: 'Change Password'
    },
    leaveEmail: {
        id: 'app.leaveEmail',
        defaultMessage: 'Leave email address field blank if you don\'t want to change the email',
        description: 'Change Password'
    },
    searchOnly: {
        id: 'app.searchOnly',
        defaultMessage: 'Search',
        description: 'Change Password'
    },
    add: {
        id: 'app.add',
        defaultMessage: 'Add',
        description: 'Add Button',
    },
    topFeatures: {
        id: 'app.topFeatures',
        defaultMessage: 'Top Features Section Settings',
        description: 'Top Features Section Settings',
    },
    managePartnerPayout: {
        id: 'app.managePartnerPayout',
        defaultMessage: 'Manage Service Provider Payouts',
        description: 'Manage Service Provider Payouts'
    },
    changeAdminPassword: {
        id: 'app.changeAdminPassword',
        defaultMessage: 'Change Admin Email/Password',
        description: 'Change Admin Email/Password'
    },
    currencyList: {
        id: 'app.currencyList',
        defaultMessage: 'Manage Currency',
        description: 'Manage Currency'
    },
    editLocation: {
        id: 'app.editLocation',
        defaultMessage: 'Edit Location',
        description: 'Edit Location'
    },
    bookingDetails: {
        id: 'app.bookingDetails',
        defaultMessage: 'Booking Details',
        description: 'Booking Details'
    },
    userAndriodVersion: {
        id: 'app.userAndriodVersion',
        defaultMessage: 'User Android Version',
        description: 'userAndriodVersion'
    },
    useriosVersion: {
        id: 'app.useriosVersion',
        defaultMessage: 'User iOS Version',
        description: 'useriosVersion'
    },
    partnerAndriodVersion: {
        id: 'app.partnerAndriodVersion',
        defaultMessage: 'Service Provider Android Version',
        description: 'Andriod'
    },
    partneriosVersion: {
        id: 'app.partneriosVersion',
        defaultMessage: 'Service Provider iOS Version',
        description: 'iOS'
    },
    forceUpdate: {
        id: 'app.forceUpdate',
        defaultMessage: 'Force update',
        description: 'forceUpdate'
    },
    invalidVersionNumber: {
        id: 'app.invalidVersionNumber',
        defaultMessage: 'Invalid Version Number',
        description: 'invalidVersionNumber'
    },
    to: {
        id: 'app.to',
        defaultMessage: 'To',
        description: 'Label'
    },
    validatePasswordLength: {
        id: 'app.validatePasswordLength',
        defaultMessage: 'Password must be minimum 8 characters',
        description: 'Password length Validation'
    },
    validateConfirmPasswordLength: {
        id: 'app.validateConfirmPasswordLength',
        defaultMessage: 'Confirm Password must be minimum 8 characters',
        description: 'Confirm Password length Validation'
    },
    validatePasswordMatch: {
        id: 'app.validatePasswordMatch',
        defaultMessage: 'Password is mismatching with Confirm password',
        description: 'Password mismatch'
    },
    itemTotal: {
        id: 'app.itemTotal',
        defaultMessage: 'Item Total',
        description: 'Label'
    },
    userBillingInformation: {
        id: 'app.userBillingInformation',
        defaultMessage: 'User Billing Information',
        description: 'Label'
    },
    partnerBillingInformation: {
        id: 'app.partnerBillingInformation',
        defaultMessage: 'Service Provider Billing Information',
        description: 'Label'
    },
    partnerEarnings: {
        id: 'app.partnerEarnings',
        defaultMessage: 'Service Provider Earnings',
        description: 'Label'
    },
    tipsReceivedFromUser: {
        id: 'app.tipsReceivedFromUser',
        defaultMessage: 'Tips received from the user',
        description: 'Label'
    },
    tipsGivenToPartner: {
        id: 'app.tipsGivenToPartner',
        defaultMessage: 'Tips given to the service provider',
        description: 'Label'
    },
    platformEarnings: {
        id: 'app.platformEarnings',
        defaultMessage: 'Platform Earnings',
        description: 'Label'
    },
    platformOffered: {
        id: 'app.platformOffered',
        defaultMessage: 'Platform Overdrafts',
        description: 'Label'
    },
    processedCash: {
        id: 'app.processedCash',
        defaultMessage: 'Processed via cash',
        description: 'Label'
    },
    completedLabel: {
        id: 'app.completedLabel',
        defaultMessage: 'Completed',
        description: 'Label'
    },
    pendingLabel: {
        id: 'app.pendingLabel',
        defaultMessage: 'Pending',
        description: 'Label'
    },
    notRequired: {
        id: 'app.notRequired',
        defaultMessage: 'No Action Required',
        description: 'Label'
    },
    paymentMethod: {
        id: 'app.paymentMethod',
        defaultMessage: 'Payment Method',
        description: 'Payment Method'
    },
    addAdminRole: {
        id: 'app.addAdminRole',
        defaultMessage: 'Add Admin Role',
        description: 'Title'
    },
    editAdminRole: {
        id: 'app.editAdminRole',
        defaultMessage: 'Edit Admin Role',
        description: 'Title'
    },
    locations: {
        id: 'app.locations',
        defaultMessage: 'Locations',
        description: 'Pagination'
    },
    addAdminUserLabel: {
        id: 'app.addAdminUserLabel',
        defaultMessage: 'Add Admin User',
        description: 'Add Admin User'
    },
    editAdminUserLabel: {
        id: 'app.editAdminUserLabel',
        defaultMessage: 'Edit Admin User',
        description: 'Edit Admin User'
    },
    completed: {
        id: 'app.completed',
        defaultMessage: 'Completed',
        description: 'Completed Status'
    },
    approved: {
        id: 'app.approved',
        defaultMessage: 'Approved',
        description: 'Approved Status'
    },
    declined: {
        id: 'app.declined',
        defaultMessage: 'Declined',
        description: 'Declined Status'
    },
    started: {
        id: 'app.started',
        defaultMessage: 'Started',
        description: 'Started Status'
    },
    cancelledByUser: {
        id: 'app.cancelledByUser',
        defaultMessage: 'Cancelled By User',
        description: 'Cancelled By User Status'
    },
    cancelledByAdmin: {
        id: 'app.cancelledByAdmin',
        defaultMessage: 'Cancelled By Admin',
        description: 'Cancelled By Admin Status'
    },
    refunded: {
        id: 'app.refunded',
        defaultMessage: 'Refunded',
        description: 'Refunded Status'
    },
    cancelledByPartner: {
        id: 'app.cancelledByPartner',
        defaultMessage: 'Cancelled By Service Provider',
        description: 'Cancelled By Service Provider Status'
    },
    expired: {
        id: 'app.expired',
        defaultMessage: 'Expired',
        description: 'Expired Status'
    },
    notRequiredMessage: {
        id: 'app.notRequiredMessage',
        defaultMessage: 'Not Required',
        description: 'Not Required'
    },
    partnerPrivacyPolicy: {
        id: 'app.partnerPrivacyPolicy',
        defaultMessage: 'Service Provider Privacy Policy',
        description: 'Title',
    },
    precautionNotification: {
        id: 'app.precautionNotification',
        defaultMessage: 'Precaution Notification',
        description: 'Title',
    },
    image: {
        id: 'app.image',
        defaultMessage: 'Image',
        description: 'Label',
    },
    updatedAt: {
        id: 'app.updatedAt',
        defaultMessage: 'Updated At',
        description: 'Label'
    },
    chatLabel: {
        id: 'app.chatLabel',
        defaultMessage: 'Chat',
        description: 'Chat'
    },
    chatMessageLabel: {
        id: 'app.chatMessageLabel',
        defaultMessage: 'Chat Message',
        description: 'Chat Message'
    },
    stripePublishableKey: {
        id: 'app.stripePublishableKey',
        defaultMessage: 'Stripe Publishable Key',
        description: 'Stripe Publishable Key'
    },
    loadMoreMsg: {
        id: 'app.loadMoreMsg',
        defaultMessage: 'Load More',
        description: 'Load more button',
    },
    noItmesFound: {
        id: 'app.noItmesFound',
        defaultMessage: 'No items found',
        description: 'No items found',
    },
    preferredDistanceType: {
        id: 'app.Preferred Distance Type',
        defaultMessage: 'Preferred Distance Type',
        description: 'Preferred Distance Type',
    },
    /**Loaded dynamically in View booking */
    km: {
        id: 'app.km',
        defaultMessage: 'Km',
        description: 'Km',
    },
    mile: {
        id: 'app.mile',
        defaultMessage: 'Mile',
        description: 'Mile',
    },
    /**Loaded dynamically in View booking */
    tracking: {
        id: 'app.tracking',
        defaultMessage: 'Tracking',
        description: 'tracking',
    },
    mapView: {
        id: 'app.mapView',
        defaultMessage: 'Map View',
        description: 'mapView',
    },
    heatMap: {
        id: 'app.heatMap',
        defaultMessage: 'HeatMap',
        description: 'heatMap',
    },
    all: {
        id: 'app.all',
        defaultMessage: 'All',
        description: 'all',
    },
    availablePartners: {
        id: 'app.availablePartners',
        defaultMessage: 'Available Service Providers',
        description: 'availablePartners',
    },
    unAvailablePartners: {
        id: 'app.unAvailablePartners',
        defaultMessage: 'Unavailable Service Providers',
        description: 'unAvailablePartners',
    },
    unActivatedPartners: {
        id: 'app.unActivatedPartners',
        defaultMessage: 'Unactivated Service Providers',
        description: 'unActivatedPartners',
    },
    activePartners: {
        id: 'app.activePartners',
        defaultMessage: 'Active Service Providers',
        description: 'activePartners'
    },
    mobileSettings: {
        id: 'app.mobileSettings',
        defaultMessage: 'Mobile App Settings',
        description: 'Mobile App Settings'
    },
    notificationInterval: {
        id: 'app.notificationInterval',
        defaultMessage: 'Job acceptance time for the service provider',
        description: 'notificationInterval'
    },
    sleepPartnerAndroid: {
        id: 'app.sleepPartnerAndroid',
        defaultMessage: 'Service Provider Android App',
        description: 'sleepPartnerAndroid'
    },
    sleepPartnerios: {
        id: 'app.sleepPartnerios',
        defaultMessage: 'Service Provider iOS App ',
        description: 'sleepPartnerios'
    },
    show: {
        id: 'app.show',
        defaultMessage: 'Show',
        description: 'show'
    },
    hide: {
        id: 'app.hide',
        defaultMessage: 'Hide',
        description: 'hide'
    },
    jobRequestWindow: {
        id: 'app.jobRequestWindow',
        defaultMessage: "Manage service provider app's job request window information",
        description: 'jobRequestWindow'
    },
    sleepMode: {
        id: 'app.sleepMode',
        defaultMessage: 'Manage Service Provider App Sleep Mode',
        description: 'sleepMode'
    },
    stripeSettings: {
        id: 'app.stripeSettings',
        defaultMessage: 'Stripe account settings',
        description: 'stripeSettings'
    },
    manageForceUpdate: {
        id: 'app.manageForceUpdate',
        defaultMessage: 'Manage Apps Force Update',
        description: 'manageForceUpdate'
    },
    allowableDistaceTitle: {
        id: 'app.allowableDistaceTitle',
        defaultMessage: 'Maximum distance to cover while fetching service providers',
        description: 'allowableDistaceTitle'
    },
    allowableDistaceField: {
        id: 'app.allowableDistaceField',
        defaultMessage: 'Maximum Allowable distance',
        description: 'allowableDistaceField'
    },
    allowedServicesTitle: {
        id: 'app.allowedServicesTitle',
        defaultMessage: 'Manage maximum jobs that users can book',
        description: 'allowedServicesTitle'
    },
    allowedServices: {
        id: 'app.allowedServices',
        defaultMessage: 'Maximum sub-categories that the users can select while requesting a job',
        description: 'allowedServices'
    },
    next: {
        id: 'app.next',
        defaultMessage: 'Next',
        description: 'Next'
    },
    invalid: {
        id: 'app.invalid',
        defaultMessage: 'Invalid',
        description: 'invalid'
    },
    manageDispatcher: {
        id: 'app.manageDispatcher',
        defaultMessage: 'Manage Dispatcher',
        description: 'manageDispatcher'
    },
    baseFare: {
        id: 'app.baseFare',
        defaultMessage: 'Base Fare',
        description: 'Label'
    },
    perMile: {
        id: 'app.perMile',
        defaultMessage: 'Per mile',
        description: 'Label'
    },
    perMinute: {
        id: 'app.perMinute',
        defaultMessage: 'Per Minute',
        description: 'Label'
    },
    minutesShort: {
        id: 'app.minutesShort',
        defaultMessage: 'mins',
        description: 'Label'
    },
    total: {
        id: 'app.total',
        defaultMessage: 'Total',
        description: 'Label'
    },
    reset: {
        id: 'app.reset',
        defaultMessage: 'Reset',
        description: 'Label'
    },
    exceedLimit200: {
        id: 'app.exceedLimit200',
        defaultMessage: 'Please dont exceed 200 words',
        description: 'Message'
    },
    perKm: {
        id: 'app.perKm',
        defaultMessage: 'Per Km',
        description: 'Label'
    },
    at: {
        id: 'app.at',
        defaultMessage: 'at',
        description: 'Label'
    },
    markerInfo: {
        id: 'app.markerInfo',
        defaultMessage: 'Marker Info',
        description: 'Marker Info'
    },
    favIconlogoLabel: {
        id: 'app.favIconlogoLabel',
        defaultMessage: 'Fav Icon',
        description: 'Fav Icon'
    },
    contactPhoneNumber: {
        id: 'app.contactPhoneNumber',
        defaultMessage: 'Contact phone number',
        description: 'contactPhoneNumber'
    },
    contactEmail: {
        id: 'app.contactEmail',
        defaultMessage: 'Contact email',
        description: 'contactEmail'
    },
    skype: {
        id: 'app.skype',
        defaultMessage: 'Skype',
        description: 'skype'
    },
    last7Days: {
        id: 'app.last7Days',
        defaultMessage: 'Last 7 days',
        description: 'select label'
    },
    allDays: {
        id: 'app.allDays',
        defaultMessage: 'All days',
        description: 'select label'
    },
    last30Days: {
        id: 'app.last30Days',
        defaultMessage: 'Last 30 days',
        description: 'select label'
    },
    addCurrency: {
        id: 'app.addCurrency',
        defaultMessage: 'Add currency',
        description: 'addCurrency'
    },
    legal: {
        id: 'app.legal',
        defaultMessage: 'Legal',
        description: 'legal',
    },
    fixedFareType: {
        id: 'app.fixedFareType',
        defaultMessage: 'Fixed fare Type',
        description: 'Fixed fare Type'
    },
    hourlyFareType: {
        id: 'app.hourlyFareType',
        defaultMessage: 'Hourly fare type',
        description: 'Hourly fare type'
    },
    subCategoryMenu: {
        id: 'app.subCategoryMenu',
        defaultMessage: 'Manage Sub Category',
        description: 'Manage SubCategory'
    },
    name: {
        id: 'app.name',
        defaultMessage: 'Name',
        description: 'name',
    },
    addSubCategory: {
        id: 'app.addSubCategory',
        defaultMessage: 'Add Sub Category',
        description: 'Add subcategory form header'
    },
    editSubCategory: {
        id: 'app.editSubCategory',
        defaultMessage: 'Edit Sub Category',
        description: 'Edit subcategory form header'
    },
    isPriceEditable: {
        id: 'app.isPriceEditable',
        defaultMessage: 'Can be editable by service provider?',
        description: 'Can be editable by service provider?',
    },
    hourlyPrice: {
        id: 'app.hourlyPrice',
        defaultMessage: 'Hourly Price',
        description: 'Hourly Price'
    },
    maxQuantity: {
        id: 'app.maxQuantity',
        defaultMessage: 'Maximum Quantity ',
        description: 'Maximum Quantity ',
    },
    minHours: {
        id: 'app.minHours',
        defaultMessage: 'Minimum Hours',
        description: 'Minimum Hours',
    },
    travelCharge: {
        id: 'app.travelCharge',
        defaultMessage: 'Visit Fee',
        description: 'Travelling Charge',
    },
    subCategory: {
        id: 'app.subCategory',
        defaultMessage: 'Sub Category',
        description: 'SubCategory'
    },
    subCategoryName: {
        id: 'app.subCategoryName',
        defaultMessage: 'Sub Category Name',
        description: 'subCategoryName'
    },
    backGroundImage: {
        id: 'app.subCatbackGroundImageegoryName',
        defaultMessage: 'Background Image',
        description: 'backGroundImage'
    },
    maximumEmergencyContact: {
        id: 'app.maximumEmergencyContact',
        defaultMessage: 'Maximum Emergency Contact',
        description: 'maximumEmergencyContact'
    },
    promoCodeImage: {
        id: 'app.promoCodeImage',
        defaultMessage: 'Promo Code Image',
        description: 'title'
    },
    availableDrivers: {
        id: 'app.availableDrivers',
        defaultMessage: 'Available Drivers',
        description: 'availableDrivers',
    },
    unAvailableDrivers: {
        id: 'app.unAvailableDrivers',
        defaultMessage: 'Unavailable Drivers',
        description: 'unAvailableDrivers',
    },
    unActivatedDrivers: {
        id: 'app.unActivatedDrivers',
        defaultMessage: 'Unactivated Drivers',
        description: 'unActivatedDrivers',
    },
    userIdentity: {
        id: 'app.userIdentity',
        defaultMessage: 'User Identity',
        description: 'userIdentity'
    },
    userExperience: {
        id: 'app.userExperience',
        defaultMessage: 'User Experience',
        description: 'userExperience'
    },
    welcomeAdminLabel: {
        id: 'app.welcomeAdminLabel',
        defaultMessage: 'Welcome Admin !!!',
        description: 'Welcome Admin !!!',
    },
    duration: {
        id: 'app.duration',
        defaultMessage: 'Job acceptance time',
        description: 'duration'
    },
    job: {
        id: 'app.job',
        defaultMessage: 'Job list',
        description: 'job'
    },
    jobDescription: {
        id: 'app.jobDescription',
        defaultMessage: 'Job description',
        description: 'jobDescription'
    },
    jobPhoto: {
        id: 'app.jobPhoto',
        defaultMessage: 'Job photos',
        description: 'hide'
    },
    estimatedPrice: {
        id: 'app.estimatedPrice',
        defaultMessage: 'Estimated price',
        description: 'estimatedPrice'
    },
    jobLocation: {
        id: 'app.jobLocation',
        defaultMessage: 'Job location',
        description: 'jobLocation'
    },
    validateInterval: {
        id: 'app.validateInterval',
        defaultMessage: 'Notification interval must be greater than 0.5 min',
        description: 'validateInterval'
    },
    userNumber: {
        id: 'app.userNumber',
        defaultMessage: 'User Phone Number',
        description: 'User Number'
    },
    partnerNumber: {
        id: 'app.partnerNumber',
        defaultMessage: 'Service Provider Phone Number',
        description: 'Service Provider Number'
    },
    additionalFee: {
        id: 'app.additionalFee',
        defaultMessage: 'Additional Charge',
        description: 'Additional Charge',
    },
    serviceFee: {
        id: 'app.serviceFee',
        defaultMessage: 'Service Fee',
        description: 'serviceFee ',
    },
    earningsLabel: {
        id: 'app.earningsLabel',
        defaultMessage: 'Earnings',
        description: 'Earnings'
    },
    jobProgress: {
        id: 'app.jobProgress',
        defaultMessage: 'Job Progress',
        description: 'jobProgress'
    },
    jobDetails: {
        id: 'app.jobDetails',
        defaultMessage: 'Job Details',
        description: 'jobDetails'
    },
    totalWorkingHours: {
        id: 'app.totalWorkingHours',
        defaultMessage: 'Total working hours =',
        description: 'Total working hours '
    },
    requestCreated: {
        id: 'app.requestCreated',
        defaultMessage: 'Request Created',
        description: 'Request Created'
    },
    requestAccepted: {
        id: 'app.requestAccepted',
        defaultMessage: 'Request Accepted',
        description: 'Request Accepted'
    },
    arrived: {
        id: 'app.arrived',
        defaultMessage: 'Arrived',
        description: 'Arrived'
    },
    requestReviewed: {
        id: 'app.requestReviewed',
        defaultMessage: 'Request Reviewed',
        description: 'Request Reviewed'
    },
    requestCancelled: {
        id: 'app.requestCancelled',
        defaultMessage: 'Request Cancelled',
        description: 'Request Cancelled'
    },
    jobStarted: {
        id: 'app.jobStarted',
        defaultMessage: 'Job Started',
        description: 'Job Started'
    },
    jobCompleted: {
        id: 'app.jobCompleted',
        defaultMessage: 'Job Completed',
        description: 'Job Completed'
    },
    totalEarnings: {
        id: 'app.totalEarnings',
        defaultMessage: 'Total Earnings',
        description: 'Earnings'
    },
    requestDecline: {
        id: 'app.requestDecline',
        defaultMessage: 'Request Declined',
        description: 'Request Declined'
    },
    showDescription: {
        id: 'app.showDescription',
        defaultMessage: 'Show more description',
        description: 'View Listing',
    },
    hideDescription: {
        id: 'app.hideDescription',
        defaultMessage: 'Hide description',
        description: 'View Listing',
    },
    subCategories: {
        id: 'app.subCategories',
        defaultMessage: 'Sub Categories',
        description: 'subCategories'
    },
    viewJob: {
        id: 'app.viewJob',
        defaultMessage: 'View job',
        description: 'view Job',
    },
    jobId: {
        id: 'app.jobId',
        defaultMessage: 'Job ID',
        description: 'Job',
    },
    requestTone: {
        id: 'app.requestTone',
        defaultMessage: 'Request accept timer tone',
        description: 'requestTone'
    },
    uploadRequestTone: {
        id: 'app.uploadRequestTone',
        defaultMessage: 'Upload timer tone',
        description: 'uploadRequestTone'
    },
    appOpenRequest: {
        id: 'app.appOpenTrip',
        defaultMessage: 'Open the provider app when a request notification is received',
        description: 'appOpenTrip'
    },
    jobs: {
        id: 'app.jobs',
        defaultMessage: 'Jobs',
        description: 'jobs',
    },
    manageSmsMethod: {
        id: 'app.manageSmsMethod',
        defaultMessage: 'Manage SMS Methods',
        description: 'manageSmsMethod',
    },
    accountId: {
        id: 'app.accountId',
        defaultMessage: 'ACCOUNT SID',
        description: 'ACCOUNT SID'
    },
    secretId: {
        id: 'app.secretId',
        defaultMessage: 'AUTHTOKEN',
        description: 'AUTHTOKEN'
    },
    apiKey: {
        id: 'app.apiKey',
        defaultMessage: 'API KEY',
        description: 'API KEY'
    },
    secretKey: {
        id: 'app.secretKey',
        defaultMessage: 'SECRET KEY',
        description: 'SECRET KEY'
    },
    noLimit: {
        id: 'app.noLimit',
        defaultMessage: 'No Limit',
        description: 'noLimit'
    },
    records: {
        id: 'app.records',
        defaultMessage: 'Records per page',
        description: 'records'
    },
    editSmsMethod: {
        id: 'app.editSmsMethod',
        defaultMessage: 'Edit SMS Methods',
        description: 'editSmsMethod',
    },
    receipt: {
        id: 'app.receipt',
        defaultMessage: 'Receipt',
        description: 'receipt'
    },
    manageSchedule: {
        id: 'app.manageSchedule',
        defaultMessage: 'Manage Schedule Booking',
        description: 'manageSchedule'
    },
    scheduleBooking: {
        id: 'app.scheduleBooking',
        defaultMessage: 'Schedule Bookings',
        description: 'Label'
    },
    scheduled: {
        id: 'app.scheduled',
        defaultMessage: 'Scheduled',
        description: 'Trip status'
    },
    scheduledFrom: {
        id: 'app.scheduledFrom',
        defaultMessage: 'Scheduled From',
        description: 'Label'
    },
    scheduledTo: {
        id: 'app.scheduledTo',
        defaultMessage: 'Scheduled To',
        description: 'Label'
    },
    scheduleBookingHistory: {
        id: 'app.scheduleBookingHistory',
        defaultMessage: 'Schedule Booking History',
        description: 'Heading'
    },
    validateScheduleInterval: {
        id: 'app.validateScheduleInterval',
        defaultMessage: 'Schedule interval must be greater than 20 min',
        description: 'validateScheduleInterval'
    },
    defaultScheduleInterval: {
        id: 'app.defaultScheduleInterval',
        defaultMessage: 'Default Schedule Interval',
        description: 'defaultScheduleInterval'
    },
    requestScheduled: {
        id: 'app.requestScheduled',
        defaultMessage: 'Request Scheduled',
        description: 'Request Scheduled'
    },
    minLableText: {
        id: 'app.minLableText',
        defaultMessage: 'min',
        description: 'min'
    },
    lightMode: {
        id: 'app.lightMode',
        defaultMessage: 'Light mode',
        description: 'Light mode',
    },
    darkMode: {
        id: 'app.darkMode',
        defaultMessage: 'Dark mode',
        description: 'Dark mode',
    },
    additionalWorkInterval: {
        id: 'app.additionalWorkInterval',
        defaultMessage: 'Additional work request acceptance time',
        description: 'additionalWorkInterval'
    },
    missedEarnings: {
        id: 'app.missedEarnings',
        defaultMessage: 'Missed earnings',
        description: 'missedEarnings'
    },
    smtpHost: {
        id: 'app.smtpHost',
        defaultMessage: 'SMTP host',
        description: 'smtpHost',
    },
    smtpPort: {
        id: 'app.smtpPort',
        defaultMessage: 'SMTP port',
        description: 'smtpPort',
    },
    smptEmail: {
        id: 'app.smptEmail',
        defaultMessage: 'SMTP email',
        description: 'smptEmail',
    },
    smtpSender: {
        id: 'app.smtpSender',
        defaultMessage: 'SMTP sender',
        description: 'smtpSender',
    },
    smtpSenderEmail: {
        id: 'app.smtpSenderEmail',
        defaultMessage: 'SMTP sender email',
        description: 'smtpSenderEmail',
    },
    smtpPassWord: {
        id: 'app.smtpPassWord',
        defaultMessage: 'SMTP password',
        description: 'smtpPassWord',
    },
    maxUploadLabel: {
        id: 'app.maxUploadLabel',
        defaultMessage: 'Maximum image upload size [MB]',
        description: 'maxUploadLabel',
    },
    manageSiteConfig: {
        id: 'app.manageSiteConfig',
        defaultMessage: 'Manage site configuration',
        description: 'manageSiteConfig',
    },
    smtpSettings: {
        id: 'app.smtpSettings',
        defaultMessage: 'SMTP settings',
        description: 'smtpSettings'
    },
    pushNotificationSettings: {
        id: 'app.pushNotificationSettings',
        defaultMessage: 'Push notification settings',
        description: 'pushNotificationSettings'
    },
    manageConfigHeading: {
        id: 'app.manageConfigHeading',
        defaultMessage: 'Config settings',
        description: 'manageConfigHeading',
    },
    otherSettings: {
        id: 'app.otherSettings',
        defaultMessage: 'Other settings',
        description: 'manageConfigHeading',
    },
    trackingCodeSettings: {
        id: 'app.trackingCodeSettings',
        defaultMessage: 'Tracking codes',
        description: 'trackingCodeSettings',
    },
    trackingCodeSettingsDesc: {
        id: 'app.trackingCodeSettingsDesc',
        defaultMessage: 'Paste tracking or verification scripts (e.g. Google Analytics/GA4, Meta Pixel, Google Tag Manager, Search Console). Header code is injected inside <head>; body code is injected right after the opening <body> tag. Applies to the public website only.',
        description: 'trackingCodeSettingsDesc',
    },
    headerCode: {
        id: 'app.headerCode',
        defaultMessage: 'Header code',
        description: 'headerCode',
    },
    bodyCode: {
        id: 'app.bodyCode',
        defaultMessage: 'Body code',
        description: 'bodyCode',
    },
    managePaymentGateWay: {
        id: 'app.managePaymentGateWay',
        defaultMessage: 'Manage payment methods',
        description: 'Manage Payment methods',
    },
    paymentGateWay: {
        id: 'app.paymentGateWay',
        defaultMessage: 'Payment methods',
        description: 'Payment methods',
    },
    googlePay: {
        id: 'app.googlePay',
        defaultMessage: 'GooglePay',
        description: 'GooglePay',
    },
    fcmPushNotificationKey: {
        id: 'app.fcmPushNotificationKey',
        defaultMessage: 'FCM push notification key',
        description: 'fcmPushNotificationKey'
    },
    reviewed: {
        id: 'app.reviewed',
        defaultMessage: 'Reviewed',
        description: 'Reviewed'
    },
    distanceFareLabel: {
        id: 'app.distanceFareLabel',
        defaultMessage: 'Distance fare type (Drop location required)',
        description: 'distanceFare'
    },
    kmLabel: {
        id: 'app.kmLabel',
        defaultMessage: 'km (Kilometre)',
        description: 'distanceFare'
    },
    distancePriceLabel: {
        id: 'app.distancePrice',
        defaultMessage: 'Distance price',
        description: 'distance Price'
    },
    minimumDistanceLabel: {
        id: 'app.minimumDistance',
        defaultMessage: 'Minimum distance',
        description: 'distance Price'
    },
    distanceTypeLabel: {
        id: 'app.distanceTypeLabel',
        defaultMessage: 'Distance type',
        description: 'distance Price'
    },
    durationLabel: {
        id: 'app.durationLabel',
        defaultMessage: 'Duration',
        description: 'Duration'
    },
    distanceLabel: {
        id: 'app.distanceLabel',
        defaultMessage: 'Distance',
        description: 'Distance'
    },
    homeSectionTitleError: {
        id: 'app.homeSectionTitleError',
        defaultMessage: 'Limit exceeded! You can enter up to 250 characters.',
        description: 'Home Section'
    },
    senderId: {
        id: 'app.senderId',
        defaultMessage: 'SENDER ID',
        description: 'phoneNumber',
    },
    descLimitError: {
        id: 'app.descLimitError',
        defaultMessage: 'Limit exceeded! You can enter up to 10,000 characters',
        description: 'Limit exceeded! You can enter up to 10,000 characters'
    },
    addLanguage: {
        id: 'app.addLanguage',
        defaultMessage: 'Add language',
        description: 'Add language'
    },
    deleteLanguage: {
        id: 'app.deleteLanguage',
        defaultMessage: 'Delete language',
        description: 'Delete language'
    },
    language: {
        id: 'app.language',
        defaultMessage: 'Language',
        description: 'Language'
    },
    addFeature: {
        id: 'app.addFeature',
        defaultMessage: 'Add feature',
        description: 'Top feature'
    },
    editFeature: {
        id: 'app.editFeature',
        defaultMessage: 'Edit feature',
        description: 'Top feature'
    },
    nameTextLimitError: {
        id: 'app.nameTextLimitError',
        defaultMessage: 'Limit exceeded! you can add up to 20 characters',
        description: 'nameTextLimitError',
    },
    inputTextLimitError: {
        id: 'app.inputTextLimitError',
        defaultMessage: 'Limit exceeded! you can add up to 250 characters',
        description: 'inputTextLimitError',
    },
    inputDescLimitError: {
        id: 'app.inputDescLimitError',
        defaultMessage: 'Limit exceeded! You can enter up to 10,000 characters',
        description: 'inputDescLimit',
    },
    preferredCurrency: {
        id: 'app.preferredCurrency',
        defaultMessage: 'Preferred currency',
        description: 'Preferred currency'
    },
    onlineProviders: {
        id: 'app.onlineProviders',
        defaultMessage: 'Online Providers',
        description: 'Online providers section heading'
    },
    available: {
        id: 'app.available',
        defaultMessage: 'Available',
        description: 'Provider available status'
    },
    busy: {
        id: 'app.busy',
        defaultMessage: 'Busy',
        description: 'Provider busy status'
    },
    lastSeen: {
        id: 'app.lastSeen',
        defaultMessage: 'Last seen',
        description: 'Last seen column'
    },
    jobColumn: {
        id: 'app.jobColumn',
        defaultMessage: 'Job',
        description: 'Job column'
    },
    provider: {
        id: 'app.provider',
        defaultMessage: 'Provider',
        description: 'Provider column'
    },
    refresh: {
        id: 'app.refresh',
        defaultMessage: 'Refresh',
        description: 'Refresh button'
    },
    noOnlineProviders: {
        id: 'app.noOnlineProviders',
        defaultMessage: 'No providers online right now',
        description: 'Empty state for online providers'
    },
    locationColumn: {
        id: 'app.locationColumn',
        defaultMessage: 'Location',
        description: 'Location column header'
    }
});

export default messages;